import { OnInit } from '@angular/core';
import { HomeUrlHelper } from '@sc/pas-common';
var RenovationsComponent = /** @class */ (function () {
    function RenovationsComponent(_urlHelper) {
        this._urlHelper = _urlHelper;
        this.origin = 'LEGACY_BASE';
        this.url = 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=Renovaciones';
        this.mode = 'EMBEDDED';
        this.token = 'NUEVO_PORTAL_TOKEN';
        this.urlLoaded = false;
    }
    RenovationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var fullUrl = this._urlHelper.urlByOrigin(this.url, this.origin);
        this._urlHelper.addTokenUrlItem(fullUrl, this.token).subscribe(function (urlParsed) {
            _this.iframeUrl = urlParsed;
            _this.urlLoaded = false;
        });
    };
    RenovationsComponent.prototype.onLoaded = function (event) {
        this.urlLoaded = true;
    };
    return RenovationsComponent;
}());
export { RenovationsComponent };
